import { Type } from '@angular/core';

import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { UserPreferenceChartColor } from '../../../Core/Users/models/user-app-preferences-chart-colors.model';
import { ChartDisplayElementModel } from '../../../Common/Reports/models/chart-display-element.model';
import { AdvancedColorPickerFieldModel, AdvancedColorPickerConfig } from '@Common/PageBuilder/models/advanced-color-picker-field.model';


export class ChartColorPickerFieldModel extends AdvancedColorPickerFieldModel {
    userPreferenceColor: UserPreferenceChartColor;
    headingId: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        colorPicker: AdvancedColorPickerConfig,
        userPreferenceColor?: UserPreferenceChartColor,
        headingId?: string,
        appearCondition?: (displayElement: ChartDisplayElementModel) => boolean
    ) {
        super({
                ...colorPicker,
                appearCondition,
                fieldComponent
        });
        this.userPreferenceColor = userPreferenceColor;
        this.headingId = headingId;
    }

}